// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Row, Col, Button, FormGroup, FormControl, Form, ControlLabel, Table } from 'react-bootstrap'
import { Link } from 'react-router'
import { MainSidebar } from '../components/mainsidebar'
import { SecSidebar } from '../components/secsidebar'
import { Message } from '../components/message'
import { Loading } from '../components/loading'
import config from '../config/config.json'

export class ManageCategories extends Component {
    constructor(props) {
        super(props)

        this.init()
        this.getWorkersByProvider(this.props.env, config)
        this.getCategories(this.props.env, config)

        this.state = {
            workers: [],
            workerCategories: [],
            displayAddCategoryButton: "block",
            displayAddCategoryForm: "none",
            loading: true
        }

        this.init = this.init.bind(this)
        this.deleteCategory = this.deleteCategory.bind(this)
        this.prepareCategoryListing = this.prepareCategoryListing.bind(this)
        this.handleAddCategory = this.handleAddCategory.bind(this)
        this.handleOnCategorySubmission = this.handleOnCategorySubmission.bind(this)
        this.handleOnClickDeleteCategory = this.handleOnClickDeleteCategory.bind(this)
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            console.log("not logged in")
            this.props.router.push('/login')
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            let data = {
                profileType: storedData.profileType,
                loginStatus: storedData.loginStatus,
                authToken: storedData.authToken,
                id: storedData.uid,
                admin_first_name: storedData.fname,
                admin_last_name: storedData.lname,
                name: storedData.company,
                address: storedData.address,
                license_count: storedData.licenseCount,
                globalModules: JSON.parse(storedData.globalModules)
            }

            this.props.handleProviderDataUpdateFromSessionStorage(data)
        }
    }

    getCategories(env, config) {
        fetch(config[env] + config.api.list_categories.endpoint, {
            method: config.api.list_categories.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    workerCategories: responseJson,
                    loading: false
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }

    addCategory(catName, env = "staging", config) {
        fetch(config[env] + config.api.add_categories.endpoint, {
            method: config.api.add_categories.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            },
            body: JSON.stringify({
                category: {
                    name: catName
                }
            })

        }).then((response) => response.json())
            .then((responseJson) => {
                this.getCategories(env, config)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    getWorkersByProvider(env, config) {
        fetch(config[env] + config.api.list_workers.endpoint, {
            method: config.api.list_workers.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }

        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    workers: responseJson
                })
            })
            .catch((error) => {
                console.error(error)
            })
    }

    deleteCategory(catId, env, config) {
        fetch(config[env] + config.api.delete_categories.endpoint + "/" + catId, {
            method: config.api.delete_categories.type,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.appData.authToken || window.sessionStorage.authToken
            }
        }).then((response) => response.json())
            .then((responseJson) => {
                this.getCategories(env, config)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    prepareCategoryListing() {
        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        else if (this.state.workerCategories.length === 0) {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Message
                            text="You don't have any categories at the moment."
                        />
                    </Col>
                </Row>
            )
        }
        else {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        {this.loadCategoryListing()}
                    </Col>
                </Row>
            )
        }
    }

    loadCategoryListing() {
        return (
            <Table responsive>
                <thead>
                    <tr><th>S.No.</th><th>Category Name</th><th>Actions</th></tr>
                </thead>
                <tbody>
                    {this.loadCategoryData(this.state.workerCategories)}
                </tbody>
            </Table>
        )
    }

    loadCategoryData(workerCategories) {
        return workerCategories.map((category, index) => {
            return (
                <tr key={index}>
                    <td>{index + 1 + "."}</td>
                    <td>{category.name}</td>
                    <td>
                        <label>
                            <Link to="#" data-categoryId={category.id} onClick={this.handleOnClickDeleteCategory}>Delete</Link>
                        </label>
                    </td>
                </tr>
            )
        })
    }

    loadAddCategoryForm() {
        return (
            <Form horizontal className="add-category-form" id="addCategory">
                <FormGroup controlId="formControlsTextarea" >
                    <Col componentClass={ControlLabel} sm={4}>
                        Category Name
                    </Col>
                    <Col sm={5}>
                        <FormControl type="textarea" placeholder="Add categories separated by a comma" inputRef={ref => { this.catgeoryInput = ref }} />
                        <FormControl.Feedback />
                    </Col>
                </FormGroup>
                <FormGroup>
                    <Col smOffset={4} sm={4}>
                        <Button type="submit" bsStyle="primary" onClick={this.handleOnCategorySubmission}>
                            Add Category
                        </Button>
                    </Col>
                </FormGroup>
            </Form>
        )
    }

    handleOnClickDeleteCategory(e) {
        e.preventDefault()

        this.deleteCategory(e.target.getAttribute('data-categoryId'), this.props.env, config)
    }

    handleAddCategory(e) {
        e.preventDefault()

        this.setState({
            displayAddCategoryButton: 'none',
            displayAddCategoryForm: 'block'
        })
    }

    handleOnCategorySubmission(e) {
        e.preventDefault()

        let categoriesToAdd = this.catgeoryInput.value.split(",")

        categoriesToAdd.forEach(category => {
            this.addCategory(category.trim(), this.props.env, config)
        })

        this.setState({
            displayAddCategoryButton: 'block',
            displayAddCategoryForm: 'none'
        })

        document.getElementById("addCategory").reset()
    }

    render() {
        let breadcrumb = (<div className="breadcrumb"><span><Link to="/workforce">Workforce</Link></span>/</div>)

        return (
            <div className="manage-categories-container page-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={1}
                    appData={this.props.appData}
                />

                <SecSidebar
                    profileType={this.props.appData.profileType}
                    menuItemsKey={"workforce"}
                    profile={4}
                />

                <div className="main-body">
                    <Row>
                        <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                            <div className="main-header">
                                {breadcrumb}
                                <h2 className="title">Manage Categories</h2>
                            </div>
                        </Col>
                    </Row>
                    {this.prepareCategoryListing()}
                    <Row style={{ "display": this.state.displayAddCategoryButton }}>
                        <Col smOffset={8} mdOffset={8} sm={3} md={3}>
                            <Button bsStyle="primary" onClick={this.handleAddCategory}>Add New Category</Button>
                        </Col>
                    </Row>
                    <Row style={{ "display": this.state.displayAddCategoryForm }}>
                        {this.loadAddCategoryForm()}
                    </Row>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/manageCategories.js